import { render } from "./ChartJs.vue?vue&type=template&id=867f9c98"
import script from "./ChartJs.vue?vue&type=script&lang=js"
export * from "./ChartJs.vue?vue&type=script&lang=js"

import "./ChartJs.vue?vue&type=style&index=0&id=867f9c98&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/element/ChartJs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "867f9c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('867f9c98', __exports__)) {
    api.reload('867f9c98', __exports__)
  }
  
  module.hot.accept("./ChartJs.vue?vue&type=template&id=867f9c98", () => {
    api.rerender('867f9c98', render)
  })

}


export default __exports__